import React, { useEffect, useState } from 'react'
import CardHeadMenu from '../../Components/Card/CardHeadMenu/CardHeadMenu'
import { useSelector } from 'react-redux';
import configServ from '../../services/config';
import CaseCard from './caseCard';
import { AnimatePresence } from "framer-motion";
import { set } from 'date-fns';
import CaseTable from './caseTable';
import { useLocation } from "react-router-dom";
const CasePage = () => {
    const location = useLocation();
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [change, setChange] = useState(false);
    const { user_id, company_id, is_super, is_admin, permissions, companyName } = useSelector(
        (state) => state.GlobalVariables
    );

    useEffect(() => {
        if (location.state && location.state.customer_id) {
            setIsCreate(true);
            setCustomerId(location.state.customer_id);
            console.log("Customer ID from location state:", location.state.customer_id);
        }
    }, [location]);

    const [companyLogo, setCompanyLogo] = useState("");


    const handlePopup = () => {
        setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
        setIsEdit(false);
        setEditData(null); // Clear edit data when toggling the popup
        setCustomerId(null); // Reset customerId when closing the popup
    };

    const handleEditData = (data) => {
        setIsEdit(true);
        setIsCreate(true);
        setEditData(data);
    };

    const fetchCustomerList = async () => {
        try {
            const result = await configServ.get_customer({
                company_id: company_id,
            });

            setCustomers(result);
            return result;
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        fetchCustomerList();
    }, [isCreate, isEdit]);

    const fetchAllCases = () => {
        setChange(!change);
    };

    const [categoryList, setCategoryList] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [groupList, setGroupList] = useState([]);

    const payload = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
    };

    const fetchMasterData = async () => {
        try {
            const [categoryRes, brandRes, groupRes] = await Promise.all([
                configServ.getcategory(payload),
                configServ.getBrand(payload),
                configServ.getGroup(payload),
            ]);

            // Category
            if (categoryRes.status === 200) {

                setCategoryList(categoryRes.data);
            }

            // Brand
            if (brandRes.status === 200) {
                const brandList = brandRes.data
                    .filter((x) => x.status === 1)
                    .sort((a, b) => a.brand_name.localeCompare(b.brand_name));

                setBrandList(brandList);
            }

            // Group
            if (groupRes.status === 200) {
                const groupList = groupRes.data
                    .filter((x) => x.status === 1)
                    .sort((a, b) => a.group_name.localeCompare(b.group_name));

                setGroupList(groupList);
            }
        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };

    useEffect(() => {
        fetchMasterData();
    }, [isCreate]);

    const fetchCategoryList = async () => {
        const categoryRes = await configServ.getcategory(payload);

        if (categoryRes.status === 200) {
            setCategoryList(categoryRes.data);

            return categoryRes.data;
        }
    };


    const assignCompanyLogo = async () => {
        try {
            const result = await configServ.company_logo({ company_id: company_id });
            if (result && result.image) {
                // Assuming the result.image is already a base64 string
                setCompanyLogo(`data:image/png;base64,${result.image}`);
            } else {
                setCompanyLogo(null); // Set as null if no logo
            }
        } catch (e) {
            console.log(e);
            setCompanyLogo(null); // Handle error by clearing logo
        }
    };

    useEffect(() => {
        assignCompanyLogo();
    }, []);


    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"CASE REGISTRATION"}
                handlePopup={handlePopup}
                create={isCreate}
                isEdit={isEdit}
                setEditData={setEditData}
            />

            <AnimatePresence>
                {isCreate && (
                    <CaseCard
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        editData={editData}
                        // clear={clear}
                        setEditData={setEditData}
                        isCreate={isCreate} // State passed as a prop
                        setIsCreate={setIsCreate} // Function passed as a prop
                        customersList={customers}
                        company_id={company_id}
                        onSeccess={fetchAllCases}
                        categoryList={categoryList}
                        brandList={brandList}
                        groupList={groupList}
                        onCategoryRefresh={fetchCategoryList}
                        customerId={customerId}
                        setCustomerId={setCustomerId}
                        fetchCustomerList={fetchCustomerList}
                        user_id={user_id}
                    />
                )}
            </AnimatePresence>

            <CaseTable
                company_id={company_id}
                configServ={configServ}
                onEdit={handleEditData}
                change={change}
                setChange={setChange}
                companyName={companyName}
                companyLogo={companyLogo}

            />

        </>
    )
}

export default CasePage
